const urlName = '/exam/v1'
export default API => ({
    // 列表
    findByCondition(data,pageNum,pageSize) {
        return API({
            url: `${urlName}/exam/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'post',
            data
        });
    },
    //   详情
    findById(id) {
        return API({
            url: `${urlName}/exam/findById?id=${id}` ,
        });
    },
    // 保存或修改
    examSave(data) {
        return API({
            url: `${urlName}/exam/save` ,
            method:  'post',
            data
        });
    },
    // 归档
    examArchive(id) {
        return API({
            url: `${urlName}/exam/archive?id=${id}` ,
            method:  'post',
        });
    },
    // 继续归档
    continueArchive(id) {
        return API({
            url: `${urlName}/exam/continueArchive?id=${id}` ,
            method:  'post',
        });
    },
    // 复制
    examCopy(id) {
        return API({
            url: `${urlName}/exam/copy?id=${id}` ,
            method:  'post',
        });
    },
    // 删除
    examDel(id) {
        return API({
            url: `${urlName}/exam/delete?id=${id}` ,
            method:  'post',
        });
    },
    // 发布
    examPublish(id) {
        return API({
            url: `${urlName}/exam/publish?id=${id}` ,
            method:  'post',
        });
    },
    //   获取被引用训练营列表
    findTrainListByExamId(id) {
        return API({
            url: `${urlName}/exam/findTrainListByExamId?id=${id}` ,
        });
    },

    // 试卷分析
    findPaperAnalysis(id) {
        return API({
            url: `${urlName}/examAnalysis/findPaperAnalysis?examId=${id}` ,
        });
    },
    // 试题分析
    findQuestionAnalysis(id) {
        return API({
            url: `${urlName}/examAnalysis/findQuestionAnalysis?id=${id}` ,
        });
    },
    // 成绩排名
    findScoreRanking(id,pageNum,pageSize) {
        return API({
            url: `${urlName}/examAnalysis/findScoreRanking?examId=${id}&pageSize=${pageSize}&pageNum=${pageNum}` ,
        });
    },
    // 成绩排名 查看  用户总体信息
    getRankInfo(examId,userId){
        return API({
            url:`${urlName}/examAnalysis/findScoreByUser?&examId=${examId}&userId=${userId}`,
            method:'get',
        })
    },
    // 成绩排名  查看 用户成绩历史得分
    getRankScoreListInfo(examId,pageNum,pageSize,userId){
        return API({
            url:`${urlName}/examAnalysis/findScoreListByUser?examId=${examId}&pageNum=${pageNum}&pageSize=${pageSize}&userId=${userId}`,
            method:'get',
        })
    },
    // 成绩排名 查看  详情
    getDetailDetailInfo(userPaperId){
        return API({
            url:`${urlName}/userPaper/findUserPaperInfo?userPaperId=${userPaperId}`,
            method:'get',
        })
    },
    findPaperList(url, data){
        return API({ url: `/raas/v1/paper/findByCondition?${url}`, method:'post', data });
    },
    findPaperDetail(id){
        return API({ url: `/raas/v1//paperManage/findById?id=${id}`, method:'get' });
    }
})
